export const assistant = {
  routeTitle: 'Operations assistant',
  routeSubtitle: 'Operations intelligence for your assets',
  inputModeText: 'Text-first',
  widget: {
    showLess: 'Show less',
    showMore: 'Show more',
    openAssistant: 'Open assistant',
    live: 'Live',
    assistantLabel: 'Assistant',
    headerSubtitle: 'Ask, inspect, schedule, reassign, or create work without leaving this screen.',
    newConversation: 'New conversation',
    close: 'Close',
    newThread: 'New thread',
    loadingConversation: 'Loading conversation…',
    emptyTitle: 'Always-on operational chat',
    emptyBody: 'Start with a natural instruction. The assistant can answer questions, propose actions, and wait for your confirmation when a change matters.',
    actorYou: 'You',
    actorAssistant: 'Assistant',
    usedWorkspaceData: 'Used workspace data',
    recommendationFallbackTitle: 'Recommendation',
    dictationInserting: 'Inserting transcript…',
    dictationFinishing: 'Finishing dictation…',
    dictationHeard: 'Heard: {{transcript}}',
    dictationListening: 'Listening…',
    messageInputLabel: 'Message the assistant',
    messagePlaceholder: 'Ask a question or tell the assistant what to do',
    messagePlaceholderShort: 'Ask or tell the assistant…',
    stopDictation: 'Stop dictation',
    dictateMessage: 'Dictate message',
    sendingMessage: 'Sending message',
    sendMessage: 'Send message',
    sending: 'Sending…',
    send: 'Send',
    composerHintPhone: 'Tap the microphone to dictate.',
    composerHintDesktop: 'Tap the microphone to dictate. `Enter` sends on hardware keyboards; `Shift + Enter` adds a new line.',
  },
  conversation: {
    newSession: 'New session',
    inputModeLabel: 'Input mode: {{mode}}',
    modeHint: 'Voice-ready transcript pipeline; text is active now.',
    retry: 'Retry',
    loadingHistory: 'Loading assistant history...',
    emptyTitle: 'Operational copilot',
    emptyBody: 'Ask for checklist drafts, inspection scheduling, job creation, work status, reassignment, risk explanation, or next-step recommendations.',
    actorYou: 'You',
    actorAssistant: 'Assistant',
    messagePlaceholder: 'Ask the assistant to create, explain, inspect, recommend, or reassign',
  },
  quickPrompts: {
    attention: 'What needs my attention right now?',
    inspectionTemplates: 'Where do I manage checklists?',
    requestsTriage: 'What requests need triage?',
    overdueJobs: 'Show me overdue jobs',
    assetNextStep: 'What should I do about this asset next?',
    assetOverdueInspections: 'Are any inspections overdue for this asset?',
    assetRiskSummary: 'Summarize risk and open work on this asset',
    scheduleNextInspection: 'Schedule the next inspection',
    assetTopNextStep: 'Recommend the highest-priority next step for this asset',
    assetOpenJobsFirst: 'What open jobs should I review first?',
    shouldScheduleInspection: 'Should I schedule an inspection?',
    requestSummarize: 'Summarize this request and suggest how to respond',
    requestToJob: 'Convert this request into a job',
    requestMissingInfo: 'What information is still missing to start work?',
    requestOwner: 'Who should own this request?',
    requestFastestPath: 'What is the fastest path to convert this request?',
    requestDraftResponse: 'Draft a professional response to the requester',
    requestJobOrInspection: 'Should this become a job or an inspection?',
    inspectionFailedFindings: 'Summarize failed findings and suggest follow-up jobs',
    inspectionMissingEvidence: 'What evidence is missing from this inspection?',
    inspectionHighestRisk: 'Explain the highest-risk failed items',
    inspectionJobsFromUrgent: 'Create jobs from urgent findings',
    jobBlocking: 'What is blocking completion of this job?',
    jobNextUpdate: 'Suggest the next update I should post',
    jobWhoElse: 'Who else should be involved in this job?',
    jobFollowUp: 'What follow-up work might be needed?',
    jobNextStepToClose: 'Recommend the next step to close this job',
    jobDraftCompletionNote: 'Draft a completion note',
    jobCreateFollowUp: 'Should I create a follow-up job?',
    templateImprove: 'How can I improve this checklist?',
    templateMissingChecks: 'What checks are missing for this asset type?',
    templateWeekly: 'Generate a practical weekly checklist',
    templateWhereManage: 'Where do I manage checklists in the app?',
  },
  card: {
    edit: 'Edit',
    doneEditing: 'Done editing',
    editHint: 'Change any of these before you confirm.',
    confirming: 'Confirming…',
    dismiss: 'Dismiss',
    working: 'Working…',
    undo: 'Undo',
    undoing: 'Undoing…',
    undone: 'Undone',
    undoHint: 'You can undo this for 10 minutes.',
    edited: 'Edited',
    fields: {
      name: 'Name',
      description: 'Description',
      placeType: 'Place type',
      address: 'Address',
      externalId: 'Reference',
      code: 'Code',
      scheduledDate: 'Due (date and time)',
      notes: 'Notes',
      title: 'Title',
      dueDate: 'Due (date and time)',
      estimatedCost: 'Estimate',
      note: 'Update',
      responseText: 'Reply',
    },
  },
  chart: {
    summary_one: '{{title}}: {{from}}',
    summary_other: '{{title}}: from {{from}} to {{to}}, {{count}} points',
  },
  context: {
    selectedAssets_one: "Asking about {{count}} selected asset",
    selectedAssets_other: "Asking about {{count}} selected assets",
    leaveOut: "Leave the selection out",
  },
  memory: {
    title: "What the assistant remembers",
    intro: "Preferences for the whole workspace, such as what you call things or who usually gets a kind of job. The assistant follows them when it answers. Everyone in the workspace can see them.",
    empty: "Nothing yet. Add one here, or ask the assistant, for example “Remember that gas safety jobs go to Northside Heating”.",
    addPlaceholder: "Something the assistant should remember",
    add: "Add",
    edit: "Edit",
    save: "Save",
    cancel: "Cancel",
    forget: "Forget",
    viaAssistant: "Added through the assistant",
    added: "Added by someone in the workspace",
    full: "The assistant remembers {{max}} things, the most it can. Forget one to add another.",
    saveFailed: "That did not save. You can change only what you added, unless you are a workspace admin.",
  },
  offline: {
    waiting: "You are offline. This will be sent when you are back online.",
    sending: "Back online. Sending…",
    fromGuide: "While you wait, the app guide may help:",
    discard: "Don’t send",
    photoNeedsConnection: "A photo needs a connection. Remove it to send the question when you are back online, or try again then.",
    queueFull: "10 questions are already waiting to send. Wait until you are back online.",
  },
  stream: {
    thinking: "Working on it…",
    lookingUp_one: "Looking things up ({{count}} so far)…",
    lookingUp_other: "Looking things up ({{count}} so far)…",
  },
  voice: {
    readAloud: "Read replies aloud",
    stopReading: "Stop reading replies aloud",
    readingAloud: "Replies are read aloud.",
    handsFree: "Hands-free",
    handsFreeOn: "Hands-free: after each reply it listens for your next question.",
  },
  briefing: {
    title: 'This week',
    stopSuggesting: 'Stop suggesting this',
    hideWeek: 'Hide until next week',
    turnOff: 'Turn off the weekly briefing',
    settingsTitle: 'Your weekly briefing',
    settingsIntro: 'A short summary of your week and a few suggested questions at the top of the assistant. This is your own setting.',
    on: 'On',
    off: 'Off',
    suggestionsOff_one: '{{count}} kind of suggestion is turned off.',
    suggestionsOff_other: '{{count}} kinds of suggestion are turned off.',
    suggestionsBackOn: 'Turn suggestions back on',
  },
  photo: {
    add: "Add a photo",
    replace: "Replace the photo",
    remove: "Remove the photo",
    attached: "Photo attached. The assistant reads it once and does not keep it.",
    addTitle: "Add a photo",
    addBody: "Take a photo or choose one. The assistant reads nameplates, readings and damage.",
    take: "Take photo",
    choose: "Choose photo",
    cancel: "Cancel",
    permissionTitle: "Permission needed",
    cameraPermissionBody: "Allow camera access in Settings to take a photo for the assistant.",
    libraryPermissionBody: "Allow photo access in Settings to choose a photo for the assistant.",
    failedTitle: "Photo not added",
    failedBody: "That photo could not be opened. Try another one.",
    defaultMessage: "What does this photo show?",
  },
  activity: {
    title: 'Assistant activity',
    subtitleAdmin: 'Every change made through the assistant in this workspace',
    subtitleMember: 'Changes you made through the assistant',
    policyTitle: 'Who can make changes through the assistant',
    policyIntroAdmin: 'Everyone keeps their own permissions: the assistant can only do what the person could do in the app.',
    policy: {
      everyone: 'Everyone',
      admins: 'Owners and admins',
      nobody: 'Nobody',
    },
    policyHelp: {
      everyone: 'Members can confirm changes the assistant prepares, within their own permissions.',
      admins: 'Members can ask questions and get advice; only owners and admins can confirm changes.',
      nobody: 'The assistant answers and advises but changes nothing. Feature requests still send.',
    },
    policyMember: {
      everyone: 'You can confirm changes the assistant prepares, within your own permissions.',
      admins: 'In this workspace only owners and admins make changes through the assistant. You can still ask it anything.',
      nobody: 'This workspace has turned off changes through the assistant. You can still ask it anything.',
    },
    saving: 'Saving…',
    saveFailed: 'Could not save that setting.',
    loadFailed: 'Could not load assistant activity.',
    refresh: 'Refresh',
    count_one: '{{count}} change',
    count_other: '{{count}} changes',
    empty: 'No changes made through the assistant yet.',
    status: {
      executed: 'Done',
      failed: 'Failed',
      undone: 'Undone',
    },
    byYou: 'by you',
    byPerson: 'by {{name}}',
  },
} as const;
